module.exports = __webpack_public_path__ + "static/media/invitation2.2980495a.pdf";